import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Clock, Loader2, Briefcase } from "lucide-react";

const STATUS_META = {
  queued: { label: "In coda", icon: Clock, color: "#555555", bg: "rgba(85,85,85,0.1)" },
  running: { label: "In esecuzione", icon: Loader2, color: "#0F3D6B", bg: "rgba(15,61,107,0.1)", spin: true },
  succeeded: { label: "Completato", icon: CheckCircle2, color: "#15803d", bg: "rgba(34,197,94,0.12)" },
  failed: { label: "Errore", icon: XCircle, color: "#C8102E", bg: "rgba(200,16,46,0.1)" },
  cancelled: { label: "Annullato", icon: XCircle, color: "#555555", bg: "rgba(85,85,85,0.1)" },
};

export default function JobsList() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = () =>
      api
        .get("/jobs")
        .then((r) => setJobs(r.data.items || []))
        .finally(() => setLoading(false));
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <div>
      <div className="adr-overline mb-3">I miei lavori</div>
      <h1 className="serif text-3xl sm:text-4xl font-semibold tracking-tight text-[#1A1A1A] mb-8">
        Lavori
      </h1>

      {loading ? (
        <div className="space-y-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="adr-skeleton h-20" />
          ))}
        </div>
      ) : jobs.length === 0 ? (
        <div className="text-center py-20 adr-card p-12">
          <Briefcase className="w-12 h-12 mx-auto mb-3 text-[#0F3D6B]/40" />
          <h3 className="serif text-xl font-semibold mb-1.5">Nessun lavoro ancora</h3>
          <p className="text-sm text-[#555555] mb-6">
            Non hai ancora avviato lavori — prova una ricetta dal catalogo.
          </p>
          <Link to="/catalogo" className="adr-btn-primary inline-block" data-testid="empty-state-cta">
            Esplora il catalogo
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {jobs.map((j) => {
            const meta = STATUS_META[j.status] || STATUS_META.queued;
            const Icon = meta.icon;
            return (
              <Link
                key={j.id}
                to={`/lavori/${j.id}`}
                className="adr-card p-5 block"
                data-testid={`job-row-${j.id}`}
              >
                <div className="flex items-center justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <div className="serif text-lg font-semibold text-[#1A1A1A] mb-1 truncate">
                      {j.output_title || j.recipe_name}
                    </div>
                    <div className="text-xs text-[#555555]">
                      Avviato il {new Date(j.created_at).toLocaleString("it-IT")} · {j.user_email}
                    </div>
                  </div>
                  <span className="adr-badge" style={{ background: meta.bg, color: meta.color }}>
                    <Icon className={`w-3.5 h-3.5 ${meta.spin ? "animate-spin" : ""}`} />
                    {meta.label}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
